"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = require("../../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InstagramIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InstagramIcon, _React$Component);

  function InstagramIcon() {
    _classCallCheck(this, InstagramIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(InstagramIcon).apply(this, arguments));
  }

  _createClass(InstagramIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          fill = _this$props.fill;
      return _react["default"].createElement("div", {
        className: this.props.theme.instagramIconCircle
      }, _react["default"].createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18"
      }, _react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: fill
      }, _react["default"].createElement("g", {
        transform: "translate(-356.000000, -224.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(230.000000, 30.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 68.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(5.000000, 31.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 54.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 29.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(108.000000, 0.000000)"
      }, _react["default"].createElement("path", {
        d: "M26.032536,12 C28.771646,12 31.00007,14.22828 30.999982,16.96728 L30.999982,25.03234 C30.999982,27.77134 28.771646,29.99962 26.032536,29.99962 L17.967204,29.99962 C15.22827,29.99962 13,27.77134 13,25.03234 L13,16.96728 C13,14.22828 15.22827,12 17.967204,12 L26.032536,12 Z M29.403024,25.03234 L29.402936,25.03234 L29.402936,16.96728 C29.402936,15.10888 27.890942,13.5967 26.032536,13.5967 L17.967204,13.5967 C16.108886,13.5967 14.597068,15.10888 14.597068,16.96728 L14.597068,25.03234 C14.597068,26.89074 16.108886,28.40292 17.967204,28.40292 L26.032624,28.40292 C27.89103,28.40292 29.403024,26.89074 29.403024,25.03234 Z M21.999958,16.36172 C24.557458,16.36172 26.638086,18.4425 26.638086,21.00004 C26.638086,23.5576 24.557458,25.6379 21.999958,25.6379 C19.442458,25.6379 17.36183,23.5576 17.36183,21.00004 C17.36183,18.4425 19.442458,16.36172 21.999958,16.36172 Z M21.999958,24.04056 C23.676754,24.04056 25.041018,22.67654 25.041018,21.00004 C25.041018,19.32308 23.676842,17.95906 21.999958,17.95906 C20.323074,17.95906 18.958898,19.32308 18.958898,21.00004 C18.958898,22.67654 20.323162,24.04056 21.999958,24.04056 Z M26.832654,15.00752 C27.14138,15.00752 27.44377,15.13202 27.66091,15.35044 C27.879194,15.56788 28.003824,15.86988 28.003824,16.17884 C28.003824,16.4867 27.879194,16.78868 27.66091,17.0071 C27.442736,17.22454 27.14138,17.35 26.832654,17.35 C26.524962,17.35 26.222572,17.22454 26.005322,17.0071 C25.78706,16.78868 25.661484,16.4867 25.661484,16.17884 C25.661484,15.86988 25.786972,15.56788 26.005322,15.35044 C26.22266,15.13202 26.524962,15.00752 26.832654,15.00752 Z",
        id: "icon_instagram"
      })))))))))));
    }
  }]);

  return InstagramIcon;
}(_react["default"].Component);

_defineProperty(InstagramIcon, "propTypes", {
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  fill: _propTypes["default"].string
});

_defineProperty(InstagramIcon, "defaultProps", {
  width: '18',
  height: '18',
  fill: '#FFF'
});

var _default = (0, _ThemeProvider.applyTheme)('InstagramIcon', InstagramIcon);

exports["default"] = _default;